export default __webpack_public_path__ + "static/media/pg-30.45f2d240.jpg";